"use client";
import React from "react";
import { Hero } from "app/components/hero";
import { HeroButtons } from "app/components/views/home/heroButtons";
import CiscoSdwanBanner from "public/cisco-sd-wan/banner.webp";
import topology from "public/cisco-sd-wan/topology.webp";
import CiscoSdWanPricing from "./components/ciscoSdWanPricing";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { AspectRatio, Flex } from "@chakra-ui/react";
import Image from "next/image";
import HardwareSoftware from "./components/hardwareSoftware";
import GettingStarted from "./components/gettingStarted";
import AccordionList from "app/components/shared/AccordionList";
import { CISCO_SD_WAN_CONSTANTS, CISCO_SD_WAN_FAQ_LIST } from "./components/constants";
import CustomCarousel from "app/components/shared/CustomCarousel";
import Certificates from "app/components/views/home/Certificates";
import TalkToUs from "app/components/shared/talkToUs";

const CiscoSdWanPage = () => {
  return (
    <>
      <Hero
        title="Cisco SD-WAN"
        description={CISCO_SD_WAN_CONSTANTS.Hero_desc}
        image={CiscoSdwanBanner}
        points={CISCO_SD_WAN_CONSTANTS.Hero_points}
      >
        <HeroButtons Pricing />
      </Hero>
      <CiscoSdWanPricing />
      <SectionDivider label="Cisco SD-WAN Topology" />
      <Flex justifyContent={"center"} alignItems={"center"} data-cy="section-topology">
        <Flex
          width={{ base: "full", md: "700px", lg: "800px" }}
          justifyContent="center"
          alignItems={"center"}
        >
          <AspectRatio
            width={"full"}
            ratio={8 / 6}
            position={"relative"}
            border={"1px solid #aaa"}
          >
            <Image
              alt={"Cisco Hyperflex Topology"}
              title={"Cisco Hyperflex Topology"}
              src={topology}
              sizes="100vw"
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
        </Flex>
      </Flex>
      <HardwareSoftware />
      <GettingStarted />
      <SectionDivider label="Some FAQs Before You Buy" />
      <AccordionList items={CISCO_SD_WAN_FAQ_LIST} />
      <Certificates />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default CiscoSdWanPage;
